<template>
	<div
		class="chat-main-wrap"
		:class="{'mobile': mobile, 'landscape': orientation, 'portrait': !orientation, 'on-call': onCall}"
		ref="chat-element"
	>
		<div v-if="!mobile" class="web-warpper">
			<transition name="chat-fade">
				<div
					@click="closeOnline"
					:class="{'backdrop-filter': (isOnlineOpen || isReportOpen)}"
					v-if="isOnlineOpen || isReportOpen"
				></div>
			</transition>
			<chatNavbar v-on:closechat="closeChat" v-on:mousedown="clickHandle" ref="chat-move-target" />
      <boothchat v-if="tab === 1 && boothLocId" v-on:report="openReport" :loc_id="boothLocId"/>
      <publicchat v-if="tab === 1 && !boothLocId" v-on:report="openReport" />
			<dmwrap
				v-on:report="openReport"
				@resetchatprop="resetChatProp"
				:userid="userId"
				v-if="tab === 2"
			/>
			<transition name="chat-fade">
				<onlineparticipants @close="closeOnline" v-if="isOnlineOpen" />
			</transition>
			<transition name="chat-fade">
				<report :reportdata="reportObject" @close="closeReport" v-if="isReportOpen" />
			</transition>
			<chatToolbar
        :isBoothChat="!!boothLocId"
				:tab="tab"
				v-on:publicchat="openPublicChat"
				v-on:messaging="openDMs"
				v-on:onlineparticipants="openOnline"
			/>
		</div>

		<div class="mobile-wrapper" v-else>
			<div class="mobile-background" v-if="mobile"></div>

			<div
				@click="closeOnline"
				:class="{'backdrop-filter': (isOnlineOpen || isReportOpen), 'mobile': mobile}"
				v-if="isOnlineOpen || isReportOpen"
			></div>
			<chatNavbar
				v-on:closechat="closeChat"
				v-on:mousedown="clickHandle"
				ref="chat-move-target"
				:orientation="orientation"
				:mobile="mobile"
			/>
			<chatToolbar
				:orientation="orientation"
				:mobile="mobile"
				:tab="tab"
				v-if="(tab != 1) && !(mobile && dmSelected)"
				v-on:publicchat="openPublicChat"
				v-on:messaging="openDMs"
				v-on:onlineparticipants="openOnline"
			/>
			<publicchat
				v-on:report="openReport"
				v-if="tab === 1"
				@goback="tab = 2"
				:orientation="orientation"
				:mobile="mobile"
			/>
			<dmwrap
				v-on:report="openReport"
				:key="refreshTab"
				v-if="tab === 2"
				:orientation="orientation"
				:mobile="mobile"
				:userid="userId"
				@goback="backToDMList"
				@resetchatprop="resetChatProp"
				@dmselected="handleDmSelection"
			/>
			<onlineparticipants @close="closeOnline" v-if="isOnlineOpen" />
			<report :mobile="mobile" :reportdata="reportObject" @close="closeReport" v-if="isReportOpen" />
		</div>
	</div>
</template>

<script>
// orientation == true ===>>> landscape
// orientation == false ===>>> portrait

const CHAT_POS = "CHAT_POSITION";
import chatMixin from "./chatMixin.js";
import chatToolbar from "./ChatToolbar.vue";
import chatNavbar from "./ChatNavbar.vue";
import dmwrap from "./DMWrap.vue";
import onlineparticipants from "./Online.vue";
import publicchat from "./Public.vue";
import boothchat from "./BoothChat.vue";
import report from "./Report.vue";
export default {
	components: {
		chatToolbar,
		chatNavbar,
		dmwrap,
		onlineparticipants,
		publicchat,
    boothchat,
		report
	},
	mixins: [chatMixin],
	props: {
    onCall: Boolean,
		navigate: Object,
		orientation: Boolean,
		mobile: Boolean
	},
	data() {
		return {
			tab: 2,
			userId: null,
			isOnlineOpen: false,
			isReportOpen: false,
			reportObject: {},
			isDragging: false,
			chat: null,
			shift: {},
			windowW: {},
			isClosing: false,
			refreshTab: 0,
			dmSelected: false,
      boothLocId: null,
		};
	},
	watch: {
		navigate: {
			handler() {
				this.checkNavigate();
			}
		},
		mobile: {
			handler(val) {
				if (val) {
					this.stopResizeEvent();
					this.chat.style = null;
				} else {
					this.init();
				}
			}
		}
	},
	mounted() {
		let chat = this.$refs["chat-element"];
		this.chat = chat;
		let val = this.mobile;
		if (val) {
			this.stopResizeEvent();
			this.chat.style = null;
			this.checkNavigate();
		} else {
			this.init();
		}
	},
	beforeDestroy() {
    if (this.navigate && this.navigate.loc_id) this.resetChatProp();
		this.stopResizeEvent();
	},
	methods: {
		// INIT AND MOVEMENT OF THE CHAT
		init() {
			this.checkNavigate();
			this.restoreChatPosition();
			this.resizeEventListener();
      if (this.navigate && this.navigate.loc_id) {
        this.boothLocId = this.navigate.loc_id;
      }
		},
		backToDMList() {
			this.refreshTab++;
		},
		checkNavigate() {
			let nav = this.navigate;
			if (!nav || typeof nav !== "object") return;
			switch (nav.location) {
				case "public":
					this.tab = 1;
					break;
				case "dm":
					this.tab = 2;
					this.handleDMprop();
					break;
				case "online":
					this.isOnlineOpen = true;
					break;
			}
		},
		resetChatProp() {
			this.userId = null;
			this.$emit("resetchatprop");
		},
		handleDmSelection(bool) {
			this.dmSelected = bool;
		},
		handleDMprop() {
			let nav = this.navigate;
			if (!nav.userId) return;
			this.userId = Number(nav.userId);
		},
		resizeEventListener() {
			// saves current window width
			let w = document.documentElement.clientWidth;
			this.windowW = w;
			// adds event listener for window resize so the chat stays in place according to top-right corner instead of top-left
			window.addEventListener("resize", this.handleResize);
		},
		stopResizeEvent() {
			window.removeEventListener("resize", this.handleResize);
		},
		handleResize() {
			// calculates new X offset according to window resize
			let w = document.documentElement.clientWidth;
			let lastW = this.windowW;
			let newXoffset = lastW - w;

			try {
				// reduce chat X coordinate by new offset
				let coords = JSON.parse(localStorage.getItem(CHAT_POS));
				coords.x -= newXoffset;
				// console.log(newXoffset);

				// position chat and save new coordinates
				this.moveElement(this.chat, coords.x, coords.y);
				localStorage.setItem(CHAT_POS, JSON.stringify(coords));
			} catch (error) {
				console.warn(error);
			}
			// save new window width
			this.windowW = w;
		},
		restoreChatPosition() {
			//check for chat window's previous location from local storage and relocate it if exists else set default
			let chat = this.chat;
			let lastChatPosition = localStorage.getItem(CHAT_POS);
			lastChatPosition = lastChatPosition ? JSON.parse(lastChatPosition) : null;
			if (!lastChatPosition) {
				//default position for chat window if not previously moved
				lastChatPosition = this.getDefaultPosition(chat);
			}

			this.chat.style.display = "block";
			this.moveElement(chat, lastChatPosition.x, lastChatPosition.y);
			localStorage.setItem(CHAT_POS, JSON.stringify(lastChatPosition));
		},
		getDefaultPosition(chat) {
			//returns default position for chat window
			let defaultPosition = {
				x: window.scrollWidth - chat.clientWidth - 40,
				y: 65
			};
			return defaultPosition;
		},
		clickHandle(event) {
			// console.log(event);

			let chat = this.chat;
			let target = this.$refs["chat-move-target"];

			// check if the user clicked on the chat's navbar
			if (target.$el !== event.target) {
				return;
			}

			// save where the user clicked on the navbar to start movement from that click point
			let shiftX = event.clientX - chat.getBoundingClientRect().left;
			let shiftY = event.clientY - chat.getBoundingClientRect().top;
			this.shift = {
				x: shiftX,
				y: shiftY
			};

			// adds mousemove event to the document directly instead on the elemnent in case you move mouse too fast and lose element
			document.addEventListener("mousemove", this.onMouseMove);

			// remove global event listener upon releasing mouse left click
			document.onmouseup = () => {
				document.removeEventListener("mousemove", this.onMouseMove);
				document.onmouseup = null;
			};
		},
		onMouseMove(e) {
			// function that is passed to the mousemove event listener so it moves the chat window
			this.moveAt(e.clientX, e.clientY);
		},
		moveAt(clientX, clientY) {
			let x = clientX - this.shift.x;
			let y = clientY - this.shift.y;
			let chatH = this.chat.clientHeight;
			let chatW = this.chat.clientWidth;

			// checks if the coordinates youve sent are valid (if you move chat window there will it still be inside the browser)
			// if not, change coordinates so that chat will be on the edge of the browser
			if (x < (-chatW / 3) * 2) x = (-chatW / 3) * 2;
			if (x > window.innerWidth - (chatW / 3) * 2)
				x = window.innerWidth - (chatW / 3) * 2;
			if (y < 65) y = 65;
			if (y > window.innerHeight - (chatH / 3) * 2)
				y = window.innerHeight - (chatH / 3) * 2;
			// console.log(y);
			x = Math.round(x);
			y = Math.round(y);
			this.moveElement(this.chat, x, y);

			// saves coordinates in local storage so i can retrieve it on future component init
			let chatPos = {
				x,
				y
			};
			localStorage.setItem(CHAT_POS, JSON.stringify(chatPos));
		},
		moveElement(el, x, y) {
			// set element's X and Y coordinates on the screen

			let chatH = this.chat.clientHeight;
			let chatW = this.chat.clientWidth;
			if (x < (-chatW / 3) * 2) x = (-chatW / 3) * 2;
			if (x > window.innerWidth - (chatW / 3) * 2)
				x = window.innerWidth - (chatW / 3) * 2;
			if (y < 65) y = 65;
			if (y > window.innerHeight - (chatH / 3) * 2)
				y = window.innerHeight - (chatH / 3) * 2;
			el.style.left = x + "px";
			el.style.top = y + "px";
		},
		closeChat() {
			// emit that should be closed
			this.$emit("close");
		},

		// TOOLBAR (NAVIGATION) HANDLER
		openPublicChat() {
			this.tab = 1;
		},
		openDMs() {
			this.tab = 2;
		},
		openOnline() {
			this.isOnlineOpen = true;
		},
		closeOnline() {
			this.isOnlineOpen = false;
		},
		openReport(msg) {
			this.reportObject = msg;
			this.isReportOpen = true;
		},
		closeReport() {
			this.reportObject = {};
			this.isReportOpen = false;
		}
	}
};
</script>


<style lang="scss" scoped>
// WEB
$chat-height: 500px; // 60%
$chat-width: 800px; // 45%

.web-warpper {
	height: $chat-height;
	width: $chat-width;
}
.chat-main-wrap {
	z-index: 10;
	position: fixed;
	height: $chat-height;
	width: $chat-width;

	top: 50px;
	right: 50px;
	touch-action: none;
	border-radius: 8px;
	box-shadow: 0px 4px 25px 4px rgba(0, 0, 0, 0.15);
	background-color: rgb(255, 255, 255);
}

.backdrop-filter {
	position: absolute;
	z-index: 50;
	width: 100%;
	height: 100%;
	backdrop-filter: blur(2px) brightness(0.7);
	border-radius: 8px;
	&.mobile {
		border-radius: 0;
	}
}

// MOBILE
.mobile-wrapper {
	position: relative;
	height: calc(100% - 0px);
}
.chat-main-wrap.mobile {
	position: fixed;
	width: unset;
	height: calc(100% - 130px);
	overflow-x: auto;
	top: var(--nav-height);
	right: 0;
	border-radius: 0;
	&.landscape {
		left: var(--nav-height);
		bottom: 0;
		height: unset;
	}
	&.portrait {
		bottom: var(--nav-height);
		left: 0;
	}
	touch-action: none;
	background-color: rgb(255, 255, 255);
}
.mobile-background {
	z-index: -1;
	position: absolute;
	width: 100%;
	height: 45%;
	background: url("../../assets/backgrounds/profile-bck.png");
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position-y: -50px;
}
.on-call {
    z-index: 17;
}
</style>